import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState } from '@/modules/marketplace/discounts/store/discountSlice/initialState.ts'
import { Discount } from '@/modules/marketplace/discounts/types/Discount.ts'

const discountSlice = createSlice({
  name: 'marketplaceDiscounts',
  initialState,
  reducers: {
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    },
    setEditDiscount: (state, action: PayloadAction<Discount | null>) => {
      state.editDiscount = action.payload
    },
    setFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload
    },
    reset: () => initialState
  }
})

export const marketplaceDiscountActions = discountSlice.actions
export const { reducer: marketplaceDiscountReducer } = discountSlice
